/* 🤖 this file was generated by svg-to-ts */
export const siriusThumbsUp: {
  name: 'thumbs_up';
  data: string;
} = {
  name: 'thumbs_up',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.25 1.5a.75.75 0 0 0-.671.415L7.036 9H3a1.5 1.5 0 0 0-1.5 1.5v8.25a1.5 1.5 0 0 0 1.5 1.5h15.925a2.25 2.25 0 0 0 2.233-1.97l1.125-9a2.248 2.248 0 0 0-2.233-2.53H15v-1.5a3.751 3.751 0 0 0-3.75-3.75Zm-3 17.25h10.675a.75.75 0 0 0 .744-.657l1.125-9a.75.75 0 0 0-.744-.843h-5.8a.75.75 0 0 1-.75-.75V5.25a2.251 2.251 0 0 0-1.809-2.206L8.25 9.927v8.823Zm-5.25 0V10.5h3.75v8.25H3Z" fill="currentColor"/></svg>`
};
